// Simple component fetcher for Alpine x-data objects, x-id must be set
// useful where data objects do not need to be synced
window.$c = id => {
    const el = document.querySelector('[x-id=' + id  + ']');
    if( ! el || ! el.__x || ! el.__x.$data ) { return {} }
    return el.__x.$data;
};
window.$c_raw = id => {
    const el = document.querySelector('[x-id=' + id  + ']');
    if( ! el || ! el.__x || ! el.__x.$data ) { return {} }
    return el.__x.getUnobservedData();
};

// Utility function to get a club badge
window.clubBadge = function( id ) {
    let suffix = window.africaMen() ? 'africa/' : '';
    return id === 0 ? '/img/clubs/none.png' : '/img/clubs/' + suffix + id + '.png';
}

// Utility function to get a national flag
window.nationFlag = function( id ) {
    return id === 0 ? '/img/nations/none.png' : '/img/nations/' + id + '.png';
}

// Alpine JS compatible utility function for 20x20 images such as flags and badges
window.icon = function(source) {
    return `<img width="20" height="20" class="inline max-w-none" src="${source}">`
}

// Alpine JS compatible tooltip utility function for 20x20 images such as flags and badges
window.tooltip = function(source, name, orientation) {

    // escape slashes
    if( name != '' ) {
        name = name.replace(/'/g, "\\'");
    }

    // set class names based on orientation of bubble
    let class1, class2, class3;

    switch(orientation) {
        case 'bottom':
            class1 = 'top-full left-1/2';
            class2 = 'mt-2 -ml-6';
            class3 = 'left-0 ml-4 -mb-2 bottom-full';
        break;
        case 'right':
            class1 = 'right-0 top-1/2';
            class2 = 'right-0 mr-6 -mt-4';
            class3 = 'right-0 -mt-2 -mb-2 -mr-1 top-1/2';
        break;
        case 'left':
            class1 = 'top-0 left-1/2';
            class2 = 'ml-4 -mt-1';
            class3 = 'left-0 -mt-2 -ml-1 top-1/2 z-1';
        break;
    }

    let html =
        `<div
            x-data="{ active: false }"
            x-on:mouseover.debounce="active = true;"
            x-on:mouseleave.debounce="active = false;"
            class="relative"
        >
            <img
                width="20" height="20"
                class="inline max-w-none"
                src="${source}"
                alt="${name}"
            >
            <div
                x-cloak
                x-show.transition.origin.top="active"
                class="absolute z-1 pointer-events-none w-full h-10 ${class1}"
            >
                <div class="absolute p-2 text-sm font-medium leading-tight text-white dark:text-black rounded-lg shadow-md whitespace-nowrap z-5 bg-black dark:bg-white ${class2}">
                    <span class="relative z-2" x-text="'${name}'"></span>
                    <svg
                        class="absolute transform rotate-45 fill-current text-black dark:text-white ${class3}"
                        width="14" height="14"
                    ><rect x="0" y="0" width="100%" height="100%" /></svg>
                </div>
            </div>
        </div>`

    return html;
}

// Alpine JS compatible tooltip utility function for 20x20 images such as flags and badges
window.tooltipPlayerName = function(name, orientation) {

    // escape slashes
    if( name != '' ) {
        name = name.replace(/'/g, "\\'");
    }

    // set class names based on orientation of bubble
    let class1, class2, class3;

    switch(orientation) {
        case 'bottom':
            class1 = 'top-full left-1/2';
            class2 = 'mt-2 -ml-6';
            class3 = 'left-0 ml-4 -mb-2 bottom-full';
        break;
        case 'right':
            class1 = 'right-0 top-1/2';
            class2 = 'right-0 mr-6 -mt-4';
            class3 = 'right-0 -mt-2 -mb-2 -mr-1 top-1/2';
        break;
        case 'left':
            class1 = 'top-0 left-1/2';
            class2 = 'ml-4 -mt-1';
            class3 = 'left-0 -mt-2 -ml-1 top-1/2 z-1';
        break;
    }

    let nameParts = name.replace(/\\/g, '').split(' ');
    let shortName = nameParts.length === 1 ? nameParts : nameParts[0].substr(0,1) + '. ' + nameParts.slice(1).join(' ');
    let html =
        `<div
            x-data="{ active: false }"
            x-on:mouseover.debounce="active = true;"
            x-on:mouseleave.debounce="active = false;"
            class="relative z-1"
        >
            <div class="overflow-ellipsis whitespace-nowrap overflow-hidden">${shortName}</div>
            <div
                x-cloak
                x-show.transition.origin.top="active"
                class="absolute z-1 pointer-events-none w-full h-10 ${class1}"
            >
                <div class="absolute p-2 text-sm font-medium leading-tight text-white dark:text-black dark:bg-white rounded-lg shadow-md whitespace-nowrap z-5 bg-black ${class2}">
                    <span class="relative z-2">${name}</span>
                    <svg
                        class="absolute transform rotate-45 fill-current text-black dark:text-white ${class3}"
                        width="14" height="14"
                    ><rect x="0" y="0" width="100%" height="100%" /></svg>
                </div>
            </div>
        </div>`

    return html;
}

// Utility function to create a slug from a string - https://gist.github.com/codeguy/6684588
window.stringToSlug = function(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaaeeeeiiiioooouuuunc------";

    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

// build a URL path separated by /
window.buildPath = function( parts ) {
    return parts.join('/');
}

// generic function for when ajax calls fail
window.ajaxFail = function(response) {
    modal(getLang('generic_error') + "<br><br>" + response);
    Spruce.reset('loading');
    Spruce.store('loading', false);
    Spruce.reset('cover');
    Spruce.store('cover', false);
    $c('appMain').loading = false;
}

// captialise the first letter
window.ucFirst = function(str) {
    if (!str) return '';

    var firstCodeUnit = str[0];

    if (firstCodeUnit < '\uD800' || firstCodeUnit > '\uDFFF') {
      return str[0].toUpperCase() + str.slice(1);
    }

    return str.slice(0, 2).toUpperCase() + str.slice(2);
}
